import { Component } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ConfigurationService } from './commons/core/conf/configuration.service';
import { LogService } from './commons/core/log/log.service';
import { SessionService } from './commons/core/session/session.service';

@Component({
	selector: 'n9-app-root',
	templateUrl: './app.component.html',
})
export class AppComponent {
	constructor(
		private translateService: TranslateService,
		private logService: LogService,
		private session: SessionService,
		private conf: ConfigurationService
	) {
		const initialInfos = `${this.conf.get('app.name')} version : ${this.conf.get(
			'app.version'
		)} env : ${this.conf.get('name')}`;

			this.logService.info('-'.repeat(initialInfos.length));
			this.logService.info(initialInfos);
			this.logService.info('-'.repeat(initialInfos.length));

			// i18n configurations
			this.translateService.setDefaultLang('en-GB');
			this.translateService.use('en-GB');

			// session configurations
			this.session.load();
	}
}
